// extracted by mini-css-extract-plugin
export default {"light_item":"LightItem_light_item__mjQfH","light_item__coin_name":"LightItem_light_item__coin_name__NbStH"};